const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'avif', 'heic']
const VIDEO_EXTS = ['mp4', 'mov', 'webm', 'avi', 'mkv', 'm4v']

export function docFromUrl(url, index = 0) {
  const raw = typeof url === 'string' ? url : url?.url || ''
  const name = typeof url === 'string'
    ? decodeURIComponent((raw.split('/').pop() || '').replace(/\?.*$/, '') || `file-${index + 1}`)
    : url?.fileName || `file-${index + 1}`
  const ext = (raw.split('.').pop() || '').split('?')[0].toLowerCase()
  const fileType = IMAGE_EXTS.includes(ext) ? 'image' : VIDEO_EXTS.includes(ext) ? 'video' : 'file'
  const contentType = fileType === 'image'
    ? 'image/jpeg'
    : fileType === 'video'
      ? 'video/mp4'
      : 'application/octet-stream'
  return {
    fileId: `existing-${index}-${Date.now()}`,
    url: raw,
    fileName: name,
    contentType,
    fileType,
    size: 0,
  }
}

export function seedDocumentsFromMedia(urls) {
  return (urls || []).map((url, i) => docFromUrl(url, i))
}

export function splitUploadedDocs(docs) {
  const all = [...(docs || [])]
  return {
    existing: all.filter((d) => !d.file),
    fresh: all.filter((d) => d.file),
  }
}

export function isGroupAdmin(groupId, currentUserId, accountGroups = [], messageGroups = []) {
  if (!groupId) return false
  const uid = String(currentUserId)
  if ((accountGroups || []).some((g) => String(g.id) === String(groupId) && g.isAdmin)) return true
  const group = (messageGroups || []).find((g) => String(g.id) === String(groupId))
  const adminList = group?.groupAdminList || []
  return adminList.some((a) => String(a.userId || a) === uid)
}

export function canManageItem(item, currentUserId, isGroupAdminForItem) {
  if (!item || !currentUserId) return false
  const authorId = item.author?.userId || item.authorId || item.userId
  if (authorId && String(authorId) === String(currentUserId)) return true
  if (typeof isGroupAdminForItem === 'function') return !!isGroupAdminForItem(item)
  return false
}
